/** Kurumsal panel liste sayfaları — abonelik tabloları ile uyumlu açık tema */

import { PANEL } from "./panelTokens";

/** Canonical panel card surface — PanelCard ve liste kartları SSOT */
export const panelCardSx = {
  borderRadius: PANEL.radius.card,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
};

export const panelTableCardSx = panelCardSx;

export const panelListSectionTitleSx = {
  fontWeight: 800,
  color: PANEL.text.primary,
  letterSpacing: -0.2,
  mb: 2,
};

export const panelDataGridSx = {
  border: "none",
  color: PANEL.text.body,
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: PANEL.fill.muted,
    color: PANEL.text.primary,
    borderBottom: `1px solid ${PANEL.border}`,
    fontWeight: 700,
    fontSize: "0.78rem",
    letterSpacing: 0.2,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 700,
  },
  "& .MuiDataGrid-virtualScroller": {
    backgroundColor: PANEL.surface,
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: PANEL.fill.muted,
  },
  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${PANEL.pageBg}`,
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-footerContainer": {
    backgroundColor: PANEL.fill.muted,
    borderTop: `1px solid ${PANEL.border}`,
  },
  "& .MuiTablePagination-root": {
    color: PANEL.text.muted,
  },
  "& .MuiTablePagination-selectIcon": {
    color: PANEL.text.muted,
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-overlay": {
    color: PANEL.text.muted,
    bgcolor: PANEL.surface,
  },
};

export const panelSummaryCardSx = {
  height: "100%",
  borderRadius: PANEL.radius.card,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
  transition: "box-shadow 0.2s ease, transform 0.2s ease",
  "&:hover": {
    boxShadow: PANEL.shadow.cardHover,
    transform: "translateY(-2px)",
  },
};

export const panelSummaryAvatarSx = (accent = PANEL.accent.main) => ({
  width: 48,
  height: 48,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: PANEL.radius.avatar,
  bgcolor: `${accent}1f`,
  color: accent,
  border: `1px solid ${accent}40`,
  "& .MuiSvgIcon-root": {
    display: "block",
    fontSize: 24,
  },
});

export const panelMetaChipSx = {
  bgcolor: PANEL.pageBg,
  color: PANEL.text.meta,
  fontWeight: 600,
  border: `1px solid ${PANEL.border}`,
};

export const panelChipPositiveSx = {
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  fontWeight: 600,
  border: `1px solid ${PANEL.accent.softBorder}`,
};

export const panelChipNeutralSx = {
  bgcolor: PANEL.pageBg,
  color: PANEL.text.muted,
  fontWeight: 600,
  border: `1px solid ${PANEL.border}`,
};

export const panelChipAdminSx = {
  bgcolor: PANEL.blue.soft12,
  color: PANEL.blue.text,
  fontWeight: 600,
  border: `1px solid ${PANEL.blue.soft30}`,
};

export const panelChipDoctorSx = {
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  fontWeight: 600,
  border: `1px solid ${PANEL.accent.softBorder}`,
};

export const panelListFooterFieldSx = {
  minWidth: 150,
  "& .MuiOutlinedInput-root": {
    bgcolor: PANEL.surface,
    borderRadius: PANEL.radius.input,
    "& fieldset": { borderColor: PANEL.border },
    "&:hover fieldset": { borderColor: PANEL.fill.hover },
    "&.Mui-focused fieldset": { borderColor: PANEL.accent.main },
  },
  "& .MuiInputLabel-root": {
    color: PANEL.text.muted,
    "&.Mui-focused": { color: PANEL.accent.text },
    "&.MuiInputLabel-shrink:not(.Mui-focused)": { color: PANEL.text.muted },
  },
  "& .MuiInputBase-input": { color: PANEL.text.primary },
};

/** İstatistik filtre alanı — dış mini kart (3 kutu ayrımı) */
export const panelStatsFilterCardSx = {
  flex: 1,
  minWidth: { xs: "100%", md: 180 },
  p: 1.75,
  bgcolor: PANEL.surface,
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.filterCard,
  transition: "box-shadow 0.2s ease, transform 0.2s ease",
  "&:hover": {
    boxShadow: PANEL.shadow.filterCardHover,
  },
};

/** Kart içindeki Select — düz, gölgesiz (gölge dış kartta) */
export const panelStatsFilterFieldInnerSx = {
  width: "100%",
  "& .MuiInputLabel-root": {
    color: PANEL.text.muted,
    fontWeight: 600,
    fontSize: "0.8rem",
    "&.Mui-focused": { color: PANEL.accent.text },
    "&.MuiInputLabel-shrink": { fontWeight: 700 },
    "&.MuiInputLabel-shrink:not(.Mui-focused)": { color: PANEL.text.muted },
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: PANEL.fill.muted,
    borderRadius: PANEL.radius.input,
    transition: "background-color 0.2s ease, border-color 0.2s ease",
    "& fieldset": {
      borderColor: PANEL.border,
      borderWidth: "1px",
    },
    "&:hover": {
      bgcolor: PANEL.surface,
      "& fieldset": { borderColor: PANEL.fill.hover },
    },
    "&.Mui-focused": {
      bgcolor: PANEL.surface,
      "& fieldset": { borderColor: PANEL.accent.main, borderWidth: "1px" },
    },
  },
  "& .MuiSelect-select": {
    color: PANEL.text.primary,
    fontWeight: 500,
    py: 1.15,
    minHeight: "1.4em",
  },
  "& .MuiSvgIcon-root": { color: PANEL.text.muted },
};

export const panelFilterChipSx = {
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  fontWeight: 600,
  border: `1px solid ${PANEL.accent.softBorder}`,
  maxWidth: "100%",
  "& .MuiChip-label": {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  "& .MuiChip-deleteIcon": {
    color: PANEL.text.muted,
    fontSize: 18,
    "&:hover": {
      color: PANEL.text.primary,
      backgroundColor: PANEL.accent.soft18,
    },
  },
};

/** Kurumsal panel — Autocomplete (çoklu chip) arama alanı */
export const panelAutocompleteFieldSx = {
  width: "100%",
  "& .MuiInputLabel-root": {
    color: PANEL.text.muted,
    fontWeight: 600,
    fontSize: "0.8rem",
    "&.Mui-focused": { color: PANEL.accent.text },
    "&.MuiInputLabel-shrink": { fontWeight: 700 },
    "&.MuiInputLabel-shrink:not(.Mui-focused)": { color: PANEL.text.muted },
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: PANEL.fill.muted,
    borderRadius: PANEL.radius.input,
    flexWrap: "wrap",
    gap: 0.5,
    py: 0.75,
    alignItems: "center",
    transition: "background-color 0.2s ease, border-color 0.2s ease",
    "& fieldset": {
      borderColor: PANEL.border,
      borderWidth: "1px",
    },
    "&:hover": {
      bgcolor: PANEL.surface,
      "& fieldset": { borderColor: PANEL.fill.hover },
    },
    "&.Mui-focused": {
      bgcolor: PANEL.surface,
      "& fieldset": { borderColor: PANEL.accent.main, borderWidth: "1px" },
    },
  },
  "& .MuiAutocomplete-inputRoot": {
    flexWrap: "wrap",
    gap: 0.5,
    py: 0.75,
    alignItems: "center",
  },
  "& .MuiInputBase-input": {
    color: PANEL.text.primary,
    minWidth: 120,
    py: 0.25,
  },
  "& .MuiInputBase-input::placeholder": {
    color: PANEL.text.label,
    opacity: 1,
  },
  "& .MuiSvgIcon-root": { color: PANEL.text.muted },
};

/** Kurumsal panel — Autocomplete dropdown */
export const panelAutocompletePopperSx = {
  zIndex: (theme) => theme.zIndex.modal,
  "& .MuiAutocomplete-paper": {
    bgcolor: "transparent",
    backgroundImage: "none",
    boxShadow: "none",
    border: "none",
    borderRadius: 0,
    overflow: "visible",
    margin: 0,
  },
  "& .MuiPaper-root.MuiAutocomplete-paper": {
    bgcolor: "transparent",
    boxShadow: "none",
  },
};

/** @deprecated Kart dışında tek başına kullanım — panelStatsFilterCardSx + Inner tercih edin */
export const panelStatsFilterFieldSx = {
  width: "100%",
  "& .MuiInputLabel-root": {
    color: PANEL.text.muted,
    fontWeight: 600,
    fontSize: "0.875rem",
    "&.Mui-focused": { color: PANEL.accent.text },
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: PANEL.surface,
    borderRadius: PANEL.radius.cardMd,
    boxShadow: PANEL.shadow.input,
    transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    "& fieldset": {
      borderColor: PANEL.fill.hoverAlt,
      borderWidth: "1px",
    },
    "&:hover": {
      boxShadow: PANEL.shadow.inputHover,
      "& fieldset": { borderColor: PANEL.fill.hover },
    },
    "&.Mui-focused": {
      boxShadow: PANEL.shadow.inputFocus,
      "& fieldset": { borderColor: PANEL.accent.main, borderWidth: "1px" },
    },
  },
  "& .MuiSelect-select": {
    color: PANEL.text.primary,
    fontWeight: 500,
    py: 1.25,
    minHeight: "1.5em",
  },
  "& .MuiSvgIcon-root": { color: PANEL.text.muted },
};

/** Profil detay sayfaları */
export const panelProfileHeroCardSx = {
  ...panelTableCardSx,
  overflow: "hidden",
};

export const panelSectionOverlineSx = {
  color: PANEL.text.muted,
  letterSpacing: 0.2,
  fontWeight: 700,
  fontSize: "0.7rem",
  textTransform: "none",
};

export const panelEmptyStateSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  py: 6,
  px: 3,
  borderRadius: PANEL.radius.card,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.card,
};

export const panelEmptyStateIconWrapSx = {
  width: 72,
  height: 72,
  borderRadius: PANEL.radius.card,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: PANEL.accent.soft,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  mb: 2.5,
};

export const panelListIconActionSx = (accent = PANEL.blue.main) => ({
  flex: 1,
  borderRadius: PANEL.radius.input,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  color: accent,
  "&:hover": {
    bgcolor: `${accent}14`,
    borderColor: `${accent}55`,
  },
});

export const panelStatMiniBoxSx = {
  flex: 1,
  p: 1.5,
  borderRadius: PANEL.radius.cardMd,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
};

/** Abonelik / özet kartları — belirgin gölgeli mini kutu */
export const panelElevatedMiniCardSx = {
  p: 1.75,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.surface,
  border: `1px solid ${PANEL.border}`,
  boxShadow: PANEL.shadow.elevatedMini,
  transition: "box-shadow 0.2s ease, transform 0.2s ease",
  "&:hover": {
    boxShadow: PANEL.shadow.elevatedMiniHover,
  },
};

/** Kota progress bar dış track */
export const panelQuotaProgressTrackSx = {
  height: 12,
  width: "100%",
  borderRadius: PANEL.radius.chip,
  bgcolor: PANEL.pageBg,
  border: `1px solid ${PANEL.border}`,
  boxShadow:
    "inset 0 2px 4px rgba(15, 23, 42, 0.08), 0 2px 8px rgba(15, 23, 42, 0.06)",
  overflow: "hidden",
};

/** Kota progress bar doluluk çubuğu */
export const panelQuotaProgressFillSx = (color) => ({
  height: "100%",
  borderRadius: "7px",
  bgcolor: color,
  boxShadow: `0 1px 4px ${color}88, inset 0 1px 0 rgba(255, 255, 255, 0.35)`,
  transition: "width 0.35s ease",
});

export const panelPrimaryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  bgcolor: PANEL.accent.main,
  color: `${PANEL.accent.contrast} !important`,
  borderRadius: PANEL.radius.input,
  boxShadow: "none",
  px: 2.5,
  "&:hover": {
    bgcolor: PANEL.accent.hover,
    boxShadow: PANEL.accent.shadow,
    color: `${PANEL.accent.contrast} !important`,
  },
};

export const panelSecondaryButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  color: PANEL.text.body,
  borderColor: PANEL.border,
  bgcolor: "transparent",
  borderRadius: PANEL.radius.input,
  "&:hover": {
    borderColor: PANEL.accent.main,
    bgcolor: PANEL.fill.muted,
    color: PANEL.text.primary,
  },
};

/** Liste kartı içinde gömülü filtre alanı — tablo ile tek kart */
export const panelListFiltersEmbeddedSx = {
  pb: 2.5,
  mb: 2.5,
  borderBottom: `1px solid ${PANEL.border}`,
  "& .MuiOutlinedInput-root": {
    backgroundColor: PANEL.surface,
    borderRadius: PANEL.radius.input,
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: PANEL.border },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: PANEL.fill.hover },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: PANEL.accent.main,
    borderWidth: 1,
  },
  "& .MuiInputLabel-root": { color: PANEL.text.muted },
  "& .MuiInputBase-input": { color: PANEL.text.primary },
  "& .MuiSelect-icon": { color: PANEL.text.muted },
};

export const panelListFilterToolbarSx = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
};

/** Dashboard Analitik segment — subtle indigo hint; reads as analytics without overpowering overview. */
export const panelDashboardAnalyticsToggleSx = {
  "& .MuiSvgIcon-root": {
    color: PANEL.indigo.main,
    opacity: 0.75,
    transition: "opacity 0.2s ease, color 0.2s ease",
  },
  color: PANEL.text.body,
  "&:hover:not(.Mui-selected)": {
    bgcolor: PANEL.indigo.soft,
    color: PANEL.indigo.text,
    "& .MuiSvgIcon-root": { opacity: 0.92 },
  },
  "&.Mui-selected": {
    backgroundColor: `${PANEL.indigo.soft} !important`,
    color: `${PANEL.indigo.text} !important`,
    boxShadow: `0 2px 10px rgba(79, 70, 229, 0.14) !important`,
    border: `1px solid ${PANEL.indigo.softBorder}`,
    "& .MuiSvgIcon-root": {
      color: `${PANEL.indigo.main} !important`,
      opacity: 1,
    },
    "&:hover": {
      backgroundColor: `${PANEL.indigo.soft} !important`,
      color: `${PANEL.indigo.text} !important`,
    },
  },
};

/** Segmented control (dashboard Genel Bakış / Analitik). Selected sits on surface, not accent fill. */
export const panelSegmentedToggleGroupSx = {
  display: "flex",
  flexWrap: "wrap",
  gap: 0.5,
  bgcolor: PANEL.fill.subtle,
  borderRadius: "12px",
  p: 0.35,
  border: `1px solid ${PANEL.border}`,
  "& .MuiToggleButtonGroup-grouped": {
    borderRadius: "10px !important",
    mx: 0.25,
    border: 0,
  },
  "& .MuiToggleButton-root": {
    px: 2,
    py: 0.75,
    textTransform: "none",
    fontWeight: 600,
    color: PANEL.text.muted,
    gap: 0.75,
    "& .MuiSvgIcon-root": { fontSize: 18, color: "inherit" },
    "&.Mui-selected": {
      backgroundColor: `${PANEL.surface} !important`,
      color: `${PANEL.text.primary} !important`,
      boxShadow: PANEL.shadow.card,
      "& .MuiSvgIcon-root": { color: "inherit" },
      "&:hover": {
        backgroundColor: `${PANEL.surface} !important`,
        color: `${PANEL.text.primary} !important`,
      },
    },
  },
};

export const panelListFilterToggleButtonSx = (active = false) => ({
  textTransform: "none",
  fontWeight: 600,
  fontSize: "0.8125rem",
  minHeight: 36,
  px: 1.5,
  borderRadius: PANEL.radius.input,
  border: `1px solid ${active ? PANEL.accent.softBorder : PANEL.border}`,
  bgcolor: active ? PANEL.accent.soft12 : PANEL.surface,
  color: active ? PANEL.accent.text : PANEL.text.body,
  boxShadow: "none",
  "&:hover": {
    bgcolor: PANEL.accent.soft,
    borderColor: PANEL.accent.softBorder,
    boxShadow: "none",
  },
});

export const panelListFilterActionsSx = {
  display: "flex",
  gap: 1,
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: { xs: "stretch", sm: "flex-end" },
  mt: 2,
  pt: 2,
  borderTop: `1px solid ${PANEL.border}`,
};

export const panelListFilterClearButtonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderColor: PANEL.border,
  color: PANEL.text.muted,
  "&:hover": { borderColor: PANEL.accent.main, bgcolor: PANEL.fill.muted, color: PANEL.text.body },
};

export const panelListSectionHeaderSx = {
  px: { xs: 2, md: 2.5 },
  py: 1.75,
  borderBottom: `1px solid ${PANEL.border}`,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
  flexWrap: "wrap",
};

/** Tenant işlem geçmişi / abonelik tabloları ile uyumlu liste tablosu */
export const panelListTableContainerSx = {
  borderRadius: PANEL.radius.cardSm,
  border: `1px solid ${PANEL.border}`,
  overflow: "hidden",
  bgcolor: PANEL.surface,
};

/** Gömülü liste kartında tablo — üst sınır filtre bölümüne yapışık */
export const panelListTableContainerEmbeddedSx = {
  ...panelListTableContainerSx,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
};

export const panelListTableSx = {
  borderCollapse: "separate",
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: PANEL.fill.muted,
    color: PANEL.text.primary,
    fontWeight: 700,
    borderBottom: `1px solid ${PANEL.border}`,
    fontSize: "0.78rem",
    letterSpacing: "0.02em",
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    color: PANEL.text.body,
    borderColor: PANEL.pageBg,
    fontSize: "0.875rem",
    py: 1.35,
    verticalAlign: "middle",
  },
  "& .MuiTableRow-root:hover": {
    backgroundColor: PANEL.fill.muted,
  },
  "& .MuiTableRow-root:last-child .MuiTableCell-root": {
    borderBottom: 0,
  },
};

export const panelListTableRowExcelSx = {
  bgcolor: `${PANEL.accent.soft} !important`,
  borderLeft: `3px solid ${PANEL.accent.main}`,
  "&:hover": {
    bgcolor: `${PANEL.accent.soft18} !important`,
  },
};

export const panelListTablePaginationSx = {
  borderTop: `1px solid ${PANEL.border}`,
  color: PANEL.text.muted,
  "& .MuiTablePagination-toolbar": {
    px: { xs: 1, sm: 2 },
    minHeight: 52,
  },
  "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
    color: PANEL.text.muted,
    fontSize: "0.8125rem",
    fontWeight: 500,
  },
  "& .MuiTablePagination-input": {
    borderRadius: PANEL.radius.chip,
    border: `1px solid ${PANEL.border}`,
    bgcolor: PANEL.fill.muted,
    mr: 1,
    ml: 0.5,
    transition:
      "border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      bgcolor: PANEL.surface,
      borderColor: PANEL.fill.hover,
    },
    "&.Mui-focused": {
      bgcolor: PANEL.surface,
      borderColor: PANEL.accent.main,
      boxShadow: `0 0 0 3px ${PANEL.accent.focusRing}`,
    },
  },
  "& .MuiTablePagination-select": {
    color: PANEL.text.primary,
    fontWeight: 600,
    fontSize: "0.8125rem",
    py: 0.5,
    px: 1.25,
    pr: "24px !important",
  },
  "& .MuiTablePagination-selectIcon": {
    color: PANEL.text.muted,
    right: 4,
  },
  "& .MuiTablePagination-actions .MuiIconButton-root": {
    color: PANEL.text.muted,
    borderRadius: PANEL.radius.chip,
    "&:hover": {
      bgcolor: PANEL.accent.soft,
      color: PANEL.accent.text,
    },
    "&.Mui-disabled": {
      color: PANEL.text.label,
    },
  },
};

export const panelListTableActionButtonSx = {
  color: PANEL.text.muted,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  borderRadius: "10px",
  p: 0.65,
  "&:hover": {
    bgcolor: PANEL.accent.soft,
    color: PANEL.accent.text,
    borderColor: PANEL.accent.softBorder22,
  },
};

export { panelDialogPaperSx, tenantDialogPaperSx } from "./panelDialogSx";

export const panelHierarchyNodeSx = (variant = "default") => {
  const variants = {
    root: {
      bgcolor: PANEL.blue.soft,
      border: `1px solid ${PANEL.blue.soft25}`,
    },
    current: {
      bgcolor: PANEL.accent.soft,
      border: `2px solid ${PANEL.accent.softBorder45}`,
      boxShadow: PANEL.accent.hierarchyShadow,
    },
    default: {
      bgcolor: PANEL.surface,
      border: `1px solid ${PANEL.border}`,
    },
  };
  return {
    p: 1.5,
    borderRadius: PANEL.radius.cardMd,
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    ...variants[variant],
  };
};

/** @deprecated tenant* — geriye uyumluluk alias'ları */
export const tenantTableCardSx = panelTableCardSx;
export const tenantListSectionTitleSx = panelListSectionTitleSx;
export const tenantDataGridSx = panelDataGridSx;
export const tenantSummaryCardSx = panelSummaryCardSx;
export const tenantSummaryAvatarSx = panelSummaryAvatarSx;
export const tenantMetaChipSx = panelMetaChipSx;
export const tenantChipPositiveSx = panelChipPositiveSx;
export const tenantChipNeutralSx = panelChipNeutralSx;
export const tenantChipAdminSx = panelChipAdminSx;
export const tenantChipDoctorSx = panelChipDoctorSx;
export const tenantListFooterFieldSx = panelListFooterFieldSx;
export const tenantStatsFilterCardSx = panelStatsFilterCardSx;
export const tenantStatsFilterFieldInnerSx = panelStatsFilterFieldInnerSx;
export const tenantFilterChipSx = panelFilterChipSx;
export const tenantAutocompleteFieldSx = panelAutocompleteFieldSx;
export const tenantAutocompletePopperSx = panelAutocompletePopperSx;
export const tenantStatsFilterFieldSx = panelStatsFilterFieldSx;
export const tenantProfileHeroCardSx = panelProfileHeroCardSx;
export const tenantSectionOverlineSx = panelSectionOverlineSx;
export const tenantEmptyStateSx = panelEmptyStateSx;
export const tenantEmptyStateIconWrapSx = panelEmptyStateIconWrapSx;
export const tenantListIconActionSx = panelListIconActionSx;
export const tenantStatMiniBoxSx = panelStatMiniBoxSx;
export const tenantElevatedMiniCardSx = panelElevatedMiniCardSx;
export const tenantQuotaProgressTrackSx = panelQuotaProgressTrackSx;
export const tenantQuotaProgressFillSx = panelQuotaProgressFillSx;
export const tenantPrimaryButtonSx = panelPrimaryButtonSx;
export const tenantHierarchyNodeSx = panelHierarchyNodeSx;
